{/* Auto-generated icon - do not edit */}
import React from 'react'

interface EraserIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const EraserIcon = React.forwardRef<SVGSVGElement, EraserIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 128 117"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M64.6808 116.306C54.3621 116.906 47.9051 115.666 37.5766 115.295C35.569 115.118 33.6705 114.306 32.1578 112.977C20.8328 101.882 12.1721 88.684 3.35796 75.6511C0.086417 70.8141 0.966322 66.871 5.53897 63.0287C24.265 47.2945 53.7472 21.7341 72.7077 5.91263C73.0965 5.58942 73.7503 5.08075 74.1644 4.78599C82.8593 -1.39109 85.4965 -1.2004 91.7888 7.13569C97.763 15.0535 103.361 23.2512 109.263 31.224C113.332 36.7185 117.628 42.0482 121.84 47.4379C122.788 48.6506 123.934 49.7243 124.771 51.0036C128.673 56.9686 128.076 61.1237 122.694 65.8147C111.849 75.2665 90.1359 94.7887 79.2988 104.25C77.94 105.433 68.3081 116.094 64.6808 116.306ZM114.803 60.5561C103.955 43.2699 92.0305 26.8285 81.4241 9.92746C69.8451 19.1065 49.5341 37.99 38.5434 46.7049L80.4372 91.163C88.4849 84.1469 107.154 67.2259 114.803 60.5561ZM70.7561 99.8844C57.3187 84.5645 46.2166 67.1897 31.1956 52.9195L11.2669 70.3435C17.8864 79.9898 23.6391 89.5599 30.5697 98.1882C40.4731 110.517 35.6885 107.826 51.5253 109.217C55.8841 109.601 62.8606 108.58 62.8606 108.58C62.8606 108.58 68.6288 103.95 70.7561 99.8844Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="127" height="117" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

EraserIcon.displayName = 'EraserIcon'
